import {Button as MuiButton} from '@mui/material';
import $ from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';
import {Modal, FormGroup, ControlLabel} from 'react-bootstrap'; // eslint-disable-line no-restricted-imports
import Select from 'react-select';

import 'react-select/dist/react-select.css';
import {EVENTS} from '@cdo/apps/metrics/AnalyticsConstants';
import analyticsReporter from '@cdo/apps/metrics/AnalyticsReporter';

import {SelectStyleProps} from '../constants';
import ButtonList from '../form_components/ButtonList';
import FieldGroup from '../form_components/FieldGroup';

import style from './regionalPartnerMiniContact.module.scss';

const ROLES = [
  'Teacher',
  'Librarian',
  'Media Specialist',
  'School Administrator',
  'District Administrator',
  'Other',
];

const ROLE_MAP = ROLES.map(v => ({value: v, label: v}));
// add friendly empty value option
ROLE_MAP.unshift({value: '', label: '-'});

const GRADE_LEVEL = ['K-5', '6-8', '9-12'];

export class RegionalPartnerMiniContact extends React.Component {
  static propTypes = {
    options: PropTypes.shape({
      user_name: PropTypes.string,
      email: PropTypes.string,
      zip: PropTypes.string,
      grade_levels: PropTypes.array,
      role: PropTypes.string,
    }),
    apiEndpoint: PropTypes.string.isRequired,
    sourcePageId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      submitted: false,
      errors: [],
      name: this.props.options.user_name,
      email: this.props.options.email,
      zip: this.props.options.zip,
      notes: '',
      role: this.props.options.role,
      grade_levels: this.props.options.grade_levels,
    };
  }

  submit = () => {
    const params = {
      // set null or empty values to undefined so they are ignored
      name: this.state.name || undefined,
      email: this.state.email,
      zip: this.state.zip,
      notes: this.state.notes || undefined,
      source: this.props.sourcePageId,
      role: this.state.role || undefined,
      grade_levels: this.state.grade_levels || undefined,
    };

    this.setState({submitting: true});

    this.submitRequest = $.ajax({
      method: 'POST',
      url: this.props.apiEndpoint,
      contentType: 'application/json',
      data: JSON.stringify({form_data: params}),
      complete: result => {
        this.onSubmitComplete(result);
      },
    });
  };

  handleChange = change => {
    this.setState(change);
  };

  onRoleChange = change => {
    this.setState({role: change?.value});
  };

  onSubmitComplete = results => {
    if (
      results.responseJSON &&
      results.responseJSON.errors &&
      results.responseJSON.errors.form_data
    ) {
      if (results.responseJSON.errors.form_data) {
        this.setState({
          errors: results.responseJSON.errors.form_data,
          submitting: false,
        });

        if (
          results.responseJSON.errors.form_data.length === 1 &&
          results.responseJSON.errors.form_data.includes('regionalPartner')
        ) {
          analyticsReporter.sendEvent(EVENTS.SUBMIT_RP_CONTACT_FORM_EVENT, {
            'source page id': this.props.sourcePageId,
            'regional partner': null,
          });
        }
      }
    } else if (results.responseJSON) {
      this.setState({submitted: true, submitting: false});
      analyticsReporter.sendEvent(EVENTS.SUBMIT_RP_CONTACT_FORM_EVENT, {
        'source page id': this.props.sourcePageId,
        'regional partner': results.responseJSON['regional_partner_name'],
      });
    } else {
      this.setState({submitted: false, submitting: false});
    }
  };

  render() {
    if (this.state.submitted) {
      return (
        <div
          id={`regional-partner-mini-contact-thanks-${this.props.sourcePageId}`}
          className="regional-partner-mini-contact-thanks"
        >
          Your message has been sent. Thank you. Your Regional Partner will be
          in touch.
        </div>
      );
    } else if (
      this.state.errors.length === 1 &&
      this.state.errors.includes('regionalPartner')
    ) {
      return (
        <div
          id={`regional-partner-mini-contact-no-rp-in-zip-${this.props.sourcePageId}`}
          className="regional-partner-mini-contact-no-rp-in-zip"
        >
          Sorry we don't have a regional partner in your region at this time.
          You can reach out to{' '}
          <a href="mailto:support@code.org">support@code.org</a> with any
          questions you have.
        </div>
      );
    } else {
      return (
        <FormGroup
          id={`regional-partner-mini-contact-form-${this.props.sourcePageId}`}
          className="regional-partner-mini-contact-form"
        >
          <div className={style.intro}>
            Your local CodeAI Regional Partner provides high quality CodeAI
            professional learning to teachers, and can help guide your school or
            district on implementation, certification, funding, and more. They
            are happy to answer any questions you may have about the program!
          </div>
          <FieldGroup
            id="name"
            label="Name"
            type="text"
            required={false}
            onChange={this.handleChange}
            defaultValue={this.state.name}
            style={style}
          />
          <FieldGroup
            id="email"
            label="Email"
            type="text"
            required={true}
            onChange={this.handleChange}
            defaultValue={this.state.email}
            style={style}
          />
          {this.state.errors.includes('email') && (
            <div
              className={style.error}
              id="regional-partner-mini-contact-error-email"
            >
              Please enter an email.
            </div>
          )}
          <FieldGroup
            id="zip"
            label="School ZIP Code"
            type="text"
            required={true}
            onChange={this.handleChange}
            defaultValue={this.state.zip}
            style={style}
          />
          {this.state.errors.includes('zip') && (
            <div
              id="regional-partner-mini-contact-error-zip"
              className={style.error}
            >
              Please enter your school ZIP Code.
            </div>
          )}
          <div className={style.fieldGroup}>
            <ButtonList
              groupName="grade_levels"
              label="Grade Level(s)"
              type="check"
              onChange={this.handleChange}
              answers={GRADE_LEVEL}
              required={false}
              selectedItems={this.state.grade_levels}
              suppressLineBreak
            />
          </div>
          <FormGroup className={style.fieldGroup}>
            <ControlLabel className={style.controlLabel}>
              Your role
            </ControlLabel>
            <div className={style.roleSelect}>
              <Select
                id="role"
                value={this.state.role}
                onChange={this.onRoleChange}
                placeholder="-"
                options={ROLE_MAP}
                {...SelectStyleProps}
              />
            </div>
          </FormGroup>
          <FieldGroup
            id="notes"
            label="Questions or notes for your local Regional Partner"
            type="text"
            required={true}
            componentClass="textarea"
            onChange={this.handleChange}
            defaultValue={this.state.notes}
            style={style}
          />
          {this.state.errors.includes('notes') && (
            <div
              id="regional-partner-mini-contact-error-notes"
              className={style.error}
            >
              Please enter a message of at least 5 words for your local Regional
              Partner.
            </div>
          )}
          <div className={style.submitContainer}>
            {!this.state.submitting && (
              <MuiButton
                variant="contained"
                color="primary"
                size="medium"
                className={style.submitButton}
                id="submit"
                onClick={this.submit}
                type="button"
              >
                {'Send'}
              </MuiButton>
            )}
            {this.state.submitting && (
              <span className="fa-solid fa-spin fa-spinner" />
            )}{' '}
          </div>
        </FormGroup>
      );
    }
  }
}

export class RegionalPartnerMiniContactPopupLink extends React.Component {
  static propTypes = {
    zip: PropTypes.string,
    sourcePageId: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      showing: false,
      options: null,
    };

    $.ajax({
      type: 'GET',
      url: '/dashboardapi/v1/users/me/contact_details',
    })
      .done(results => {
        this.setState({
          options: {
            user_name: results.user_name,
            email: results.email,
            zip: `${this.props.zip || results.zip}`,
            notes: results.notes,
          },
        });
      })
      .fail(() => {
        this.setState({
          options: {zip: this.props.zip},
        });
      });
  }

  open = () => {
    this.setState({showing: true});
  };

  close = () => {
    this.setState({showing: false});
  };

  render() {
    return (
      <span>
        <span onClick={this.open}>{this.props.children}</span>
        <Modal show={this.state.showing} onHide={this.close}>
          <Modal.Header closeButton className={style.modalHeader} />
          <Modal.Body className={style.modalBody}>
            <div className={style.miniContactContainer}>
              {this.state.options && (
                <RegionalPartnerMiniContact
                  options={this.state.options}
                  apiEndpoint="/dashboardapi/v1/pd/regional_partner_mini_contacts/"
                  sourcePageId={this.props.sourcePageId}
                />
              )}
            </div>
          </Modal.Body>
        </Modal>
      </span>
    );
  }
}
